import { render, staticRenderFns } from "./vehicleinspactions.html?vue&type=template&id=635da045&scoped=true&"
import script from "./vehicleinspactions.vue?vue&type=script&lang=js&"
export * from "./vehicleinspactions.vue?vue&type=script&lang=js&"
import style0 from "./vehicleinspactions.vue?vue&type=style&index=0&id=635da045&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635da045",
  null
  
)

export default component.exports